import React from "react";
import "./InformationBlock.sass"
import PropTypes from "prop-types";

export default function InformationBlock(props) {

    const {children, align} = props

    const style = {
        justifyContent: align ? align : "center"
    }

    return (
        <div style={style} className="information-block-wrapper">
            {children}
        </div>
    )
}

InformationBlock.propTypes = {
    align: PropTypes.string
}